import { createContext, useContext } from 'react'

/**
 * Whether the list a cell sits in is in its compact view, which drops the
 * secondary lines, such as the id under the name, to fit more rows on screen.
 */
export const CompactTableContext = createContext(false)

export function useCompactTable() {
  return useContext(CompactTableContext)
}
